const touchclick: any = {
    /*
    * touch代替click
    * 方法接收参数func
    * 数据接收参数arg
    * 用法-传参：v-touchclick='{"func": add, "arg": item}'
    * 用法-不传参：v-touchclick='add'
    */
    bind(el: any, binding: any) {
        let  keyFlag: boolean,    //是否触发按键
        startX: number, startY: number; //开始触摸的坐标
        el.addEventListener('touchstart', (e: any) => {
            e.stopPropagation();
            if (binding.expression) {
                startX = e.touches[0].clientX;
                startY = e.touches[0].clientY;
                keyFlag = true;
                binding.value(true)
            }
        });
        el.addEventListener('touchmove', (e: any) => {    //阻止滑动触发输入（增加滑动触发范围）
            if (binding.expression) {
                let  y: boolean = Math.abs(startY - e.touches[0].clientY) >= 30;
                if (y) {
                    keyFlag = true;
                }else{
                    keyFlag = false;
                }
            }
        });
        el.addEventListener('touchend', (e: any) => {    //触发输入
            e.stopPropagation();
            if (binding.expression) {
                if(el.scrollTop + el.clientHeight == el.scrollHeight){//滑动到底部了
                    binding.value(false)
                }else{
                    if(keyFlag){
                        //执行传入的的操作...
                        if (binding.value && binding.value.func) { // 传参调用
                            binding.value.func(binding.value.arg,e)
                        } else {
                            binding.value(keyFlag)
                        }
                    }
                }

            }
        });
    }
}

export default touchclick
